// import { Geolocation } from '@capacitor/geolocation';
// import { SSIDPlugin } from 'capacitor-ssid-plugin';
// import api from './api';


// async function sendAttendance(employeeId: string) {
//   try {
//     const { coords } = await Geolocation.getCurrentPosition({
//       enableHighAccuracy: true
//     });

//     let wifiSSID = null;
//     try {
//       const ssidResult = await (SSIDPlugin as any).getSSID();
//       wifiSSID = ssidResult.ssid;
//     } catch (e) {
//       console.warn("Wi-Fi SSID not available", e);
//     }

//     const response = await api.post("/api/attendance/auto-clock", {
//       employee_id: employeeId,
//       latitude: coords.latitude,
//       longitude: coords.longitude,
//       wifi_ssid: wifiSSID
//     });

//     console.log("Attendance sent successfully", response.data);
//   } catch (err) {
//     console.error("Error sending attendance", err);
//   }
// }

// export const getAttendanceDayWise = async (id,sd,ed) => {
//   try {
//     console.log('API: Fetching employees from /api/employees');
//     const response = await api.get(`/attendance_daywise_working_hours?user_id=${id}&start_date=${sd}&end_date=${ed}`);
//     console.log('API: Successfully fetched employees:', response.data.day_wise_working_hours);
//     return {data : response.data.day_wise_working_hours};
//   } catch (error: any) {
//     console.error('API: Error fetching employees:', error);
//     throw new Error(error?.response?.data?.error || error.message);
//   }
// };


// attendanceApi.ts
import api from '../api/api';
import { Geolocation } from '@capacitor/geolocation';
import { SSIDPlugin } from 'capacitor-ssid-plugin';

export interface AttendanceWorkingHour {
  date: string;
  shift_duration: string;
  In_time: string;
  out_time: string;
  total_working_hours: string;
  total_working_hours_words: string;
  total_hours: number;
}

export interface AttendanceStatus {
  name: string;
  status: string;
  from_date?: string;
  clock_in_time?: string;
  out_time?: string;
  user_id?: string;
}

export interface TodayAttendance {
  name: string;
  date: string;
  clock_in_time?: string;
  additional_in_time?: string;
  additional_out_time?: string;
  end_time?: string;
  total_time?: string;
}

export interface PieData {
  name: string;
  value: number;
}

// Get attendance day-wise working hours for an employee
export const getAttendanceDayWise = async (userId: string, startDate: string, endDate: string) => {
  try {
    const response = await api.get(`/attendance_daywise_working_hours`, {
      params: {
        user_id: userId,
        start_date: startDate,
        end_date: endDate
      }
    });
    return response.data?.data || [];
  } catch (error: any) {
    console.error('Error fetching attendance day-wise:', error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Get attendance summary
export const getAttendanceSummary = async (startDate: string, endDate: string) => {
  try {
    const response = await api.get(`/attendance_summary`, {
      params: {
        start_date: startDate,
        end_date: endDate
      }
    });
    return response.data;
  } catch (error: any) {
    console.error('Error fetching attendance summary:', error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Get attendance status for a specific date
export const getAttendanceStatus = async (attendanceDate: string) => {
  try {
    const response = await api.get(`/attendance_status`, {
      params: {
        attendance_date: attendanceDate
      }
    });
    return response.data;
  } catch (error: any) {
    console.error('Error fetching attendance status:', error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Send auto-clock attendance
export const sendAutoClockAttendance = async (employeeId: string) => {
  try {
    // Get current location
    const { coords } = await Geolocation.getCurrentPosition({
      enableHighAccuracy: true
    });

    // Get Wi-Fi SSID if available
    let wifiSSID = null;
    try {
      const ssidResult = await (SSIDPlugin as any).getSSID();
      wifiSSID = ssidResult.ssid;
    } catch (e) {
      console.warn("Wi-Fi SSID not available", e);
    }

    // Send attendance to API
    const response = await api.post("/api/attendance/auto-clock", {
      employee_id: employeeId,
      latitude: coords.latitude,
      longitude: coords.longitude,
      wifi_ssid: wifiSSID
    });

    return response.data;
  } catch (err: any) {
    console.error("Error sending attendance", err);
    throw new Error(err?.response?.data?.error || err.message);
  }
};

// Export attendance to CSV
export const exportAttendanceToCSV = (attendanceData: AttendanceStatus[]) => {
  const headers = ["Name", "In Time", "Out Time", "Status"];
  const rows = attendanceData.map((emp) => [
    emp.name,
    emp.clock_in_time || "-",
    emp.out_time || "-",
    emp.status || "-",
  ]);

  let csvContent = headers.join(",") + "\n" + rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  const today = new Date().toISOString().split("T")[0];
  link.setAttribute("download", `attendance_${today}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};